import { render, staticRenderFns } from "./WorkspaceFactorLoadingsPanel.vue?vue&type=template&id=afd51c08&scoped=true"
import script from "./WorkspaceFactorLoadingsPanel.vue?vue&type=script&lang=js"
export * from "./WorkspaceFactorLoadingsPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceFactorLoadingsPanel.vue?vue&type=style&index=0&id=afd51c08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd51c08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd51c08')) {
      api.createRecord('afd51c08', component.options)
    } else {
      api.reload('afd51c08', component.options)
    }
    module.hot.accept("./WorkspaceFactorLoadingsPanel.vue?vue&type=template&id=afd51c08&scoped=true", function () {
      api.rerender('afd51c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceFactorLoadingsPanel.vue"
export default component.exports